import type { CartQuery } from "../lib/api";
import type { CartProcessingStrategy } from "./interfaces";

import { DefaultCartProcessingStrategy } from "./strategies/DefaultCartProcessingStrategy";
import { NubuCartProcessingStrategy } from "./strategies/NubuCartProcessingStrategy";

const processors: CartProcessingStrategy[] = [
  new NubuCartProcessingStrategy()
];

export default function getCartProcessingStrategy(cart: CartQuery['Cart']): CartProcessingStrategy {
  for (const strategy of processors) {
    if (!strategy.supports(cart)) {
      continue;
    }

    return strategy;
  }

  return new DefaultCartProcessingStrategy();
}
